<template>
    <div class="calculator-cont weight-calculator">
        <general-calculator :conversionFactors="areaCalcUnits" :labelSuffix="areaCalcLabel" :showSplitter="true"></general-calculator>

    </div>
</template>
<script>
import GeneralCalculator from './GeneralCalculator.vue';
import ConversionFactors from '../../utils/conversion_factors';
import { ref, watchEffect } from 'vue';
import { useI18n } from 'vue-i18n';
export default {
    name: 'AreaConversion',
    components: {
        GeneralCalculator,
    },
    setup() {

        const { t } = useI18n();

        const areaCalcUnits = ConversionFactors.area;
        const areaCalcLabel = ref(t('Area'));

        watchEffect(() => {
            areaCalcLabel.value = t('Area');
        });

        return { areaCalcUnits, areaCalcLabel };
        
    },
}
</script>

<style>
/* Add some basic styling */

@media (min-width: 768px){
  .text-label {
    min-width: 180px;
  }
}



</style>